var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldenPackage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 46,
    viewBox: "0 0 74 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5684_1688)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9985 44.6116L59.8438 28.0016L51.1187 1.125H22.8782L14.1501 28.0016L36.9985 44.6116Z",
    fill: "#104556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.934 0H22.06L12.8284 28.4302L36.9955 46L61.1626 28.4302L51.934 0ZM17.609 26.8766L25.0153 4.07003H48.9816L56.3879 26.8766L37.0015 40.9732L17.612 26.8766H17.609Z",
    fill: "url(#paint0_radial_5684_1688)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0154 4.07031L36.9985 40.9705L48.9817 4.07031H25.0154Z",
    fill: "#0C363D"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9339 0H22.06L19.9259 6.57743C21.2537 6.63741 22.6295 6.80537 24.0382 7.07531L25.0153 4.07003H48.9816L56.3879 26.8766L53.5764 28.9221C54.2089 30.1518 54.7694 31.4235 55.2489 32.7342L61.1656 28.4332L51.9339 0Z",
    fill: "url(#paint1_radial_5684_1688)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M51.9339 0H22.06L19.9259 6.57743C21.2537 6.63741 22.6295 6.80537 24.0382 7.07531L25.0153 4.07003H48.9816L56.3879 26.8766L53.5764 28.9221C54.2089 30.1518 54.7694 31.4235 55.2489 32.7342L61.1656 28.4332L51.9339 0Z",
    fill: "url(#paint2_linear_5684_1688)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M50.2945 36.3328C50.1536 34.7492 49.9169 33.2406 49.5991 31.8099L36.9956 40.9727L17.6061 26.8761L22.9233 10.5C21.4127 10.536 19.926 10.707 18.4843 11.0009L12.8254 28.4297L36.9926 45.9995L50.2915 36.3298L50.2945 36.3328Z",
    fill: "url(#paint3_linear_5684_1688)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.609 26.8769L19.5243 26.445L26.1992 5.89088H47.7947L54.4696 26.445L56.3849 26.8769L48.9786 4.07031H25.0153L17.609 26.8769Z",
    fill: "#9E2C19"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5244 26.4447L23.259 16.856C25.471 11.1784 30.935 8.71595 37.0255 8.71595C43.14 8.71595 48.625 11.2114 50.816 16.925L54.4697 26.4447L47.7948 5.89062H26.1963L19.5214 26.4447H19.5244Z",
    fill: "#892334"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.609 26.8772L19.5243 26.4453L36.9985 39.1503L54.4696 26.4453L56.3849 26.8772L36.9985 40.9708L17.609 26.8772Z",
    fill: "url(#paint4_linear_5684_1688)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5243 26.4447L26.3761 8.85092C26.7058 8.00212 27.5241 7.44125 28.4352 7.44125H45.6546C46.5688 7.44125 47.3901 8.00512 47.7168 8.85992L54.4667 26.4447L47.7917 5.89062H26.1933L19.5183 26.4447H19.5243Z",
    fill: "#892334"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0154 4.07031L26.1993 5.89088H47.7948L48.9787 4.07031H25.0154Z",
    fill: "#681D15"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1404 18.2363L13.8265 26.9103C13.6467 27.6571 14.0004 28.6498 14.6178 29.1117L36.9985 46.0037L12.8314 28.4339L16.1434 18.2393L16.1404 18.2363Z",
    fill: "#9E2C19"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5243 26.4453L36.1922 37.6806C36.6328 37.9776 37.3581 37.9776 37.7987 37.6806L54.4667 26.4453L36.9955 39.1473L19.5243 26.4453Z",
    fill: "#892334"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9985 45.9995L58.5191 29.3655C60.0237 28.2497 60.3504 28.0068 59.673 25.8683L55.1831 9.99609L61.1687 28.4297L37.0015 45.9995H36.9985Z",
    fill: "#9E2C19"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3162 33.2086L36.9985 40.9708L51.4184 30.4883L36.9985 41.6306L26.3162 33.2086Z",
    fill: "#FFF5CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1863 0H51.934L55.1801 9.99661L51.3316 0.554867L36.1863 0Z",
    fill: "#FFF5CC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4535 0C42.3216 1.29569 42.8881 2.74434 43.9791 4.07003H48.9816L50.2195 7.87912C51.7871 8.26303 53.2857 8.27502 54.5146 7.9391L51.9339 0H42.4535Z",
    fill: "#FFF2BB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0184 32.2637C24.6407 33.2384 25.3241 34.6901 26.6999 35.6889C28.0756 36.6876 29.6672 36.8916 30.4735 36.2317L25.0154 32.2637H25.0184Z",
    fill: "#FFF2BB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5123 38.8895C30.2815 39.2434 29.6431 39.2374 29.0886 38.8745C28.5341 38.5116 28.2674 37.9297 28.4982 37.5758C28.729 37.2219 29.3674 37.2279 29.9219 37.5908C30.4764 37.9537 30.7431 38.5356 30.5123 38.8895Z",
    fill: "#FFF2BB"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7072 0.198101L18.793 7.76529C16.6289 7.75329 14.8216 7.7443 11.5695 7.7473C0.0599448 7.76229 0 0.162109 0 0.162109L19.7072 0.198101Z",
    fill: "#681D15"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7072 0.198101L17.7619 6.10969C15.5979 6.09769 15.2412 6.08869 11.9921 6.09469C0.482562 6.10669 0 0.162109 0 0.162109L19.7072 0.198101Z",
    fill: "url(#paint5_radial_5684_1688)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7907 9.18352L15.8916 16.7507C13.7275 16.7387 16.3591 16.7507 13.1101 16.7507C1.6005 16.7657 1.52856 9.14453 1.52856 9.14453L16.7937 9.18052L16.7907 9.18352Z",
    fill: "#681D15"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7908 9.18352L14.8665 15.1071C12.7025 15.0951 16.7908 15.0861 13.5387 15.0891C2.02912 15.1041 1.52258 9.14453 1.52258 9.14453L16.7878 9.18052L16.7908 9.18352Z",
    fill: "url(#paint6_radial_5684_1688)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8744 18.1658L5.76672 18.1328C5.76672 18.1328 7.04057 23.8314 12.9722 25.736L13.8774 18.1658H13.8744Z",
    fill: "#681D15"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8744 18.1658L5.76672 18.1328C5.76672 18.1328 6.0185 22.1848 11.9501 24.0924L13.8774 18.1658H13.8744Z",
    fill: "url(#paint7_radial_5684_1688)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7072 0.197266L20.6783 2.07482L18.793 7.76446L17.762 6.10885L19.7072 0.197266Z",
    fill: "#9E2C19"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7908 9.18359L17.762 11.0431L15.8887 16.7538L14.8666 15.1072L16.7908 9.18359Z",
    fill: "#9E2C19"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8714 18.1699L14.8425 20.0265L12.9692 25.7371L11.9471 24.0935L13.8714 18.1699Z",
    fill: "#9E2C19"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2928 0.198101L55.207 7.76529C57.3711 7.75329 59.1784 7.7443 62.4305 7.7473C73.9401 7.76229 74 0.162109 74 0.162109L54.2928 0.198101Z",
    fill: "#681D15"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2928 0.197055L56.2381 6.10864C58.4021 6.09664 58.7588 6.08765 62.0079 6.09365C73.5174 6.10864 74 0.164062 74 0.164062L54.2928 0.200054V0.197055Z",
    fill: "url(#paint8_radial_5684_1688)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2092 9.18352L58.1084 16.7507C60.2724 16.7387 57.6408 16.7507 60.8898 16.7507C72.3994 16.7657 72.4714 9.14453 72.4714 9.14453L57.2062 9.18052L57.2092 9.18352Z",
    fill: "#681D15"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2092 9.18352L59.1335 15.1071C61.2975 15.0951 57.2092 15.0861 60.4613 15.0891C71.9709 15.1041 72.4774 9.14453 72.4774 9.14453L57.2122 9.18052L57.2092 9.18352Z",
    fill: "url(#paint9_radial_5684_1688)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1256 18.1658L68.2332 18.1328C68.2332 18.1328 66.9594 23.8314 61.0277 25.736L60.1226 18.1658H60.1256Z",
    fill: "#681D15"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1256 18.1658L68.2332 18.1328C68.2332 18.1328 67.9814 22.1848 62.0498 24.0924L60.1226 18.1658H60.1256Z",
    fill: "url(#paint10_radial_5684_1688)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M54.2928 0.197055L56.2381 6.10864C58.4021 6.09664 58.7588 6.08765 62.0079 6.09365C73.5174 6.10864 74 0.164062 74 0.164062L54.2928 0.200054V0.197055Z",
    fill: "url(#paint11_linear_5684_1688)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M57.2092 9.18352L59.1335 15.1071C61.2975 15.0951 57.2092 15.0861 60.4613 15.0891C71.9709 15.1041 72.4774 9.14453 72.4774 9.14453L57.2122 9.18052L57.2092 9.18352Z",
    fill: "url(#paint12_linear_5684_1688)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M60.1256 18.1658L68.2332 18.1328C68.2332 18.1328 67.9814 22.1848 62.0498 24.0924L60.1226 18.1658H60.1256Z",
    fill: "url(#paint13_linear_5684_1688)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2929 0.197266L53.3218 2.07482L55.2071 7.76446L56.2381 6.10885L54.2929 0.197266Z",
    fill: "#9E2C19"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2092 9.18359L56.238 11.0431L58.1113 16.7538L59.1334 15.1072L57.2092 9.18359Z",
    fill: "#9E2C19"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1286 18.1699L59.1575 20.0265L61.0308 25.7371L62.0529 24.0935L60.1286 18.1699Z",
    fill: "#9E2C19"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M19.7072 0.198101L0 0.162109C0 0.162109 0.482562 6.10669 11.9921 6.09169C15.2442 6.08869 15.5979 6.09769 17.7619 6.10969L19.7072 0.198101Z",
    fill: "url(#paint14_linear_5684_1688)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M13.8744 18.1658L5.76672 18.1328C5.76672 18.1328 6.0185 22.1848 11.9501 24.0924L13.8774 18.1658H13.8744Z",
    fill: "url(#paint15_linear_5684_1688)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M14.8665 15.1074L15.9995 11.6133C14.4559 12.1172 12.9932 12.783 11.6474 13.6078C11.0899 13.9497 10.4365 14.3696 9.72314 14.8405C10.8381 15.0025 12.103 15.0924 13.5387 15.0924C16.7907 15.0894 12.7024 15.0984 14.8665 15.1104V15.1074Z",
    fill: "url(#paint16_linear_5684_1688)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6859 16.559L21.7333 2.0755C22.2549 0.605855 22.6355 0.218948 24.1911 0.161961L36.9985 0H22.063L16.6859 16.559Z",
    fill: "#9E2C19"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5124 2.26233C40.4693 1.50351 39.2104 1.45552 38.7009 2.15435C38.3382 2.65523 38.4581 3.40505 38.9407 4.06789H42.6843C42.6274 3.45604 42.2047 2.76621 41.5094 2.26233H41.5124Z",
    fill: "#FFF2BB"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.131 23.6186L46.2212 18.2649V16.6243L40.0408 18.2649L36.9536 12.9082L33.8634 18.2649L27.683 16.6243V18.2649L30.7732 23.6186L27.683 27.3348V28.9724H33.8634L36.9536 34.3291L40.0408 28.9724H46.2212V27.3348L43.131 23.6186Z",
    fill: "#892334"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M43.131 21.9819L46.2212 16.6252V14.6217L40.0408 16.6252L36.9536 11.2715L33.8634 16.6252L27.683 14.6217V16.6252L30.7732 21.9819L27.683 25.3321V27.3356H33.8634L36.9536 32.6894L40.0408 27.3356H46.2212V25.3321L43.131 21.9819Z",
    fill: "#9E2C19"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M43.131 19.978L46.2212 14.6213H40.0408L36.9536 9.26758L33.8634 14.6213H27.683L30.7732 19.978L27.683 25.3317H33.8634L36.9536 30.6855L40.0408 25.3317H46.2212L43.131 19.978Z",
    fill: "url(#paint17_radial_5684_1688)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2212 25.332H40.0408V27.3356H46.2212V25.332Z",
    fill: "#681D15"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8634 27.3356L36.9536 32.6893V30.6858L33.8634 25.332H27.683V27.3356H33.8634Z",
    fill: "#681D15"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M34.8435 12.9238L33.8634 14.6214H27.683L30.7732 19.9751L27.683 25.3289H33.8634L36.9536 30.6826L40.0438 25.3289H46.2242L43.134 19.9751L43.4787 19.3783C41.0029 16.541 38.0356 14.3965 34.8465 12.9238H34.8435Z",
    fill: "url(#paint18_linear_5684_1688)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.683 14.6211L30.7732 19.9778L30.1947 20.9796L27.683 16.6246V14.6211Z",
    fill: "#681D15"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.683 14.6211L31.3127 19.222C31.7263 19.7769 31.8522 19.9748 31.3127 20.7276L27.683 25.3285L30.7732 19.9748L27.683 14.6211Z",
    fill: "#9E2C19"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9536 9.26758L39.9329 15.1492L46.2212 14.6213H40.0408L36.9536 9.26758Z",
    fill: "#FFE67B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.683 25.331L34.4449 24.7461L36.9536 30.6847L33.8634 25.331H27.683Z",
    fill: "#FFE67B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9536 30.6858L39.3664 24.7772C39.6302 24.2134 39.9749 24.1504 40.3765 24.2283L46.2242 25.3321H40.0438L36.9536 30.6858Z",
    fill: "#9E2C19"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M44.6477 17.3474L46.2212 14.6211H41.2937C42.4507 15.4729 43.5716 16.3817 44.6477 17.3474Z",
    fill: "url(#paint19_linear_5684_1688)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M39.2106 13.1786L36.9536 9.26758L35.8446 11.1901C36.9866 11.799 38.1106 12.4648 39.2106 13.1786Z",
    fill: "url(#paint20_linear_5684_1688)"
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2045 19.7618C38.725 20.5926 37.3043 20.6736 36.0334 19.9388C34.7626 19.2039 34.1211 17.9352 34.6007 17.1014C35.0803 16.2706 36.501 16.1897 37.7718 16.9245C39.0427 17.6593 39.6841 18.928 39.2045 19.7618Z",
    fill: "#FCE265"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6098 20.2724C34.4569 20.5394 33.9504 20.5334 33.4798 20.2634C33.0092 19.9905 32.7514 19.5556 32.9073 19.2887C33.0602 19.0217 33.5667 19.0277 34.0373 19.2977C34.5079 19.5706 34.7656 20.0055 34.6098 20.2724Z",
    fill: "#FCE265"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7558 5.65987C57.443 5.5279 56.5288 5.05401 55.9294 3.87829L54.2928 0.201172L56.2381 6.11276C58.4021 6.10076 58.7588 6.09176 62.0079 6.09476C63.8422 6.09476 65.3948 5.9478 66.7106 5.69586C63.8572 6.04078 60.9288 5.87881 58.7558 5.66287V5.65987Z",
    fill: "#9E2C19"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4612 15.0922C63.2457 15.0952 65.3858 14.7473 67.0283 14.2224C64.6634 14.8792 62.6762 14.8342 61.1656 14.7413C60.1255 14.6783 59.2803 13.9135 58.8397 12.9687L57.2122 9.18359L59.1364 15.1072C61.3005 15.0952 57.2122 15.0862 60.4642 15.0892L60.4612 15.0922Z",
    fill: "#9E2C19"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0528 24.0935C63.3386 23.6796 64.3547 23.1667 65.161 22.6149C64.2048 22.9778 62.4125 23.2417 62.4125 23.2417L60.1285 18.1699V18.1759L62.0528 24.0935Z",
    fill: "#9E2C19"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9921 6.09469C15.2442 6.09169 15.5979 6.10069 17.7619 6.11269L19.3025 1.42781L18.1576 3.9832C17.6091 5.32987 17.2824 5.77377 15.9396 5.78576C14.4919 5.79776 11.7614 5.76777 10.3736 5.71378C4.33108 5.47684 0.7733 2.86446 0 0.162109C0 0.162109 0.482562 6.10669 11.9921 6.09169V6.09469Z",
    fill: "#9E2C19"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1243 13.3612C14.7587 14.129 14.366 14.7709 13.5178 14.7409C12.6396 14.7109 10.1758 14.6929 8.76708 14.375C5.49704 13.6372 3.5458 12.4195 2.224 10.9258C3.33599 12.6804 6.1984 15.1008 13.5418 15.0918C16.7938 15.0888 12.7055 15.0978 14.8696 15.1098L16.4611 10.209L15.1273 13.3642L15.1243 13.3612Z",
    fill: "#9E2C19"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9472 24.0934L13.6257 18.9257C13.311 19.5855 12.6845 21.1091 12.0491 22.5188C11.6175 23.4786 11.2039 23.3586 10.5385 23.0797C7.22647 21.7 6.46516 20.0594 5.76379 18.1309C5.76379 18.1309 6.01557 22.1829 11.9472 24.0904V24.0934Z",
    fill: "#9E2C19"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2928 0.198101L72.3155 0.507027C73.0409 0.519024 73.3766 1.06189 73.0619 1.71574C72.7351 2.39657 72.2076 3.21238 71.3444 3.91421C73.8322 2.22262 74 0.162109 74 0.162109L54.2928 0.198101Z",
    fill: "#FFF5CC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2092 9.18338L70.5052 9.49531C72.0578 9.5283 71.806 10.1881 71.4014 10.9979C71.1526 11.4958 70.8109 12.0417 70.3583 12.4976C72.3245 10.896 72.4744 9.15039 72.4744 9.15039L57.2092 9.18638V9.18338Z",
    fill: "#FFF5CC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8395 21.1111C68.1433 19.5545 68.2332 18.1328 68.2332 18.1328L60.1375 18.1658H60.1285L66.8215 18.4507C67.8106 18.5107 67.6307 18.8826 67.5168 19.3625C67.385 19.9174 67.1632 20.5682 66.8395 21.1111Z",
    fill: "#FFF5CC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23926 0.162109L19.7072 0.198101L19.2216 1.67675C19.2216 0.917929 18.8619 0.53402 17.9897 0.525023L5.23926 0.162109Z",
    fill: "#FFE67B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23926 9.18359H16.7908L16.2603 10.8212L16.3172 10.2783C16.3472 9.76545 16.1644 9.49552 15.2292 9.45053L5.24226 9.18359H5.23926Z",
    fill: "#FFE67B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32532 18.1397L13.8744 18.1667L13.3768 19.6933L13.3469 18.9825C13.3289 18.5866 13.221 18.4516 12.6815 18.4157L7.32831 18.1367L7.32532 18.1397Z",
    fill: "#FFE67B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2381 6.11018C57.6318 6.10418 58.2762 6.09518 59.4272 6.09518C61.4684 4.81449 62.8261 2.91294 63.0179 0.69947C63.0329 0.525512 63.0389 0.354553 63.0389 0.183594L54.2928 0.19859L56.2381 6.11018Z",
    fill: "#FFF2BB"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M1.52563 9.14844C1.52563 9.14844 1.60956 10.1142 2.45479 11.2629C3.71066 10.5521 5.11039 9.82628 6.60604 9.16043L1.52563 9.14844Z",
    fill: "url(#paint21_linear_5684_1688)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5684_1688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9108 1.53563) scale(38.3383 38.3638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E8B321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36C0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5684_1688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8854 -3.68612) scale(53.04 53.0753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E8B321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36C0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5684_1688",
    x1: 59.1754,
    y1: -7.46222,
    x2: 35.1148,
    y2: 22.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEE366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBD45F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6BC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F09945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E86D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DE3719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D40000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5684_1688",
    x1: 20.8911,
    y1: 40.6008,
    x2: 41.9252,
    y2: 14.2508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5684_1688",
    x1: 36.9985,
    y1: 23.0861,
    x2: 36.9985,
    y2: 31.1002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F7D24A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7E399"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5684_1688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3042 -6.00142) scale(42.5525 42.5808)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E8B321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36C0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_5684_1688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3041 -6.00185) scale(42.5525 42.5808)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E8B321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36C0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_5684_1688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3041 -6.00242) scale(42.5525 42.5808)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E8B321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36C0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_5684_1688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1198 0.910883) scale(43.9732 44.0025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E8B321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36C0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_5684_1688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1198 0.911498) scale(43.9732 44.0025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E8B321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36C0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_5684_1688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1198 0.910928) scale(43.9762 44.0055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E8B321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36C0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5684_1688",
    x1: 66.6357,
    y1: -2.77523,
    x2: 43.3656,
    y2: 28.8284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEE366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBD45F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6BC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F09945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E86D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DE3719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D40000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5684_1688",
    x1: 71.3714,
    y1: 0.710548,
    x2: 48.1044,
    y2: 32.3172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEE366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBD45F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6BC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F09945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E86D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DE3719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D40000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5684_1688",
    x1: 75.2888,
    y1: 3.59528,
    x2: 52.0188,
    y2: 35.1989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEE366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBD45F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6BC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F09945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E86D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DE3719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D40000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5684_1688",
    x1: 31.987,
    y1: -28.2861,
    x2: 8.717,
    y2: 3.31756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEE366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBD45F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6BC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F09945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E86D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DE3719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D40000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5684_1688",
    x1: 2.9253,
    y1: 30.046,
    x2: 20.9856,
    y2: 2.88055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5684_1688",
    x1: 2.4847,
    y1: 29.7529,
    x2: 20.545,
    y2: 2.58753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE447"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_5684_1688",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2498 0.815602) scale(43.7664 43.7955)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E8B321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36C0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5684_1688",
    x1: 27.2963,
    y1: 34.5487,
    x2: 45.0207,
    y2: 7.83592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D40000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5684_1688",
    x1: 56.3611,
    y1: -4.06744,
    x2: 35.1807,
    y2: 27.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEE366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBD45F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6BC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F09945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E86D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DE3719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D40000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5684_1688",
    x1: 50.7831,
    y1: -7.79834,
    x2: 29.5998,
    y2: 23.8821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEE366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBD45F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6BC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F09945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E86D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DE3719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D40000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5684_1688",
    x1: 31.7323,
    y1: -28.4746,
    x2: 8.46225,
    y2: 3.13208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEE366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FBD45F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F6BC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F09945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E86D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#DE3719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D40000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5684_1688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 46,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenPackage);
export default __webpack_public_path__ + "static/media/Golden-package.6727c4b1.svg";
export { ForwardRef as ReactComponent };